import React from 'react';
import './style.css';

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

import ImageIcon from '@material-ui/icons/Image';
import { ProductTable } from '..';
import { useUser } from '../../Context/User';

const Products = ({ next, prev, addMore }) => {
    const { cart } = useUser();
    return (
        <div className="confirm_products">
            <ProductTable addMore={addMore} products={[...cart]} />

            <div className="confirm_products_summary">
                <div className="confirm_products_summary_sumup">
                    <p>Subtotal: (1 ITEM(S))</p>
                    <p>₹ 183.75</p>
                </div>
            </div>
            <div className="confirm_product_footer">
                <div className="confirm_product_footer_left">
                    <button className="btn-orange ">
                        <ImageIcon className="btn-icon" />
                        <p>Add Design</p>
                    </button>
                </div>
                <div className="confirm_product_footer_right">
                    <button onClick={prev} style={{ marginRight: '2rem' }} className="btn-gray">
                        <KeyboardBackspaceIcon className="btn-icon " />
                        <p>Back</p>
                    </button>
                    <button onClick={next} className="btn-orange ">
                        <p>Proceed</p>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Products;
